module.exports = __webpack_public_path__ + "img/source3_t.72aeb0f7.png";